import React from "react";

const WavingHand = () => {
  const handStyle = {
    fontSize: "30px",
    display: "inline-block",
    transformOrigin: "70% 70%",
    animation: "wave 2s 1",
  };

  const keyframes = `
    @keyframes wave {
      0% { transform: rotate(0deg); }
      10% { transform: rotate(14deg); }
      20% { transform: rotate(-8deg); }
      30% { transform: rotate(14deg); }
      40% { transform: rotate(-4deg); }
      50% { transform: rotate(10deg); }
      60% { transform: rotate(0deg); }
      100% { transform: rotate(0deg); }
    }
  `;

  return (
    <>
      <style>{keyframes}</style>
      <div style={handStyle}>👋</div>
    </>
  );
};

export default WavingHand;
